module.exports = __webpack_public_path__ + "img/p-one-step-04.357112bd.png";